export function uploadClaimFields(primarySignedUpload, thumbnailSignedUpload = null) {
  const fields = {};

  if (typeof primarySignedUpload?.upload_claim === "string" && primarySignedUpload.upload_claim) {
    fields.upload_claim = primarySignedUpload.upload_claim;
  }

  if (typeof thumbnailSignedUpload?.upload_claim === "string" && thumbnailSignedUpload.upload_claim) {
    fields.thumbnail_upload_claim = thumbnailSignedUpload.upload_claim;
  }

  return fields;
}
